import React from 'react'
import { Link } from '@sentecacommerce-theme/lib'
import styled from 'styled-components'
import Logo from '../../../../public/svg/LogoHippoland'
import { IconPhone, Typography } from '../../../Common'

export const CheckoutMenu = ({
  children,
  phone,
}: {
  children: any
  phone: string
}) => {
  return (
    <Container>
      <Header>
        <LogoContainer>
          <Link href="/" passHref>
            <a>
              <Logo />
            </a>
          </Link>
        </LogoContainer>
        <PhoneContainer>
          <IconPhone />
          <a href={`tel:${phone}`}>{phone}</a>
        </PhoneContainer>
      </Header>
      {children}
    </Container>
  )
}

const Container = styled.div``

const Header = styled.div.attrs({
  className: 'd-flex justify-content-between align-items-center mb-5',
})``

const PhoneContainer = styled(Typography).attrs({
  className: 'd-flex align-items-center mr-4 mr-lg-0',
  color: 'greyTitle',
})`
  transition: opacity 0.2s ease;

  & > svg {
    width: 1.6rem;
    margin-right: 0.6rem;
  }

  &:hover {
    opacity: 0.6;
  }
`

const LogoContainer = styled.div.attrs({
  className: 'd-flex align-items-center justify-content-center ml-3 ml-lg-0',
})`
  & a {
    display: block;
    width: 9rem;
  }

  & img {
    width: 100%;
  }
`
